<template>
  <v-container fluid>
    <v-flex xs12>
      <UserSingle />
    </v-flex>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import UserSingle from './../components/User/UserSingle.vue';

export default {
  name: 'users',
  components: {
    UserSingle,
  },
  methods: {
    ...mapActions('users', [
      'getSingleUser',
    ]),
  },
  mounted() {
    const userId = this.$route.params.id;
    this.getSingleUser(userId);
  },
};
</script>
